// src/components/ImageToPDF.js

import React, { useState } from 'react';
import { jsPDF } from 'jspdf';
import './Dashboard.css';
import { ReactComponent as IconImage } from './icons/image.svg';

const ImageToPDF = () => {
  const [imageData, setImageData] = useState(null);

  const handleImageUpload = (e) => {
    const reader = new FileReader();
    reader.onload = function (event) {
      setImageData(event.target.result);
    };
    reader.readAsDataURL(e.target.files[0]);
  };

  const handleConvert = () => {
    if (!imageData) return;
    const pdf = new jsPDF();
  // draw a thin border on the page
  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();
  const margin = 10;
  pdf.setLineWidth(0.5);
  pdf.rect(margin / 2, margin / 2, pageWidth - margin, pageHeight - margin);
  // add image inside the border
  pdf.addImage(imageData, 'JPEG', margin, margin, pageWidth - margin * 2, pageHeight - margin * 2);
    pdf.save('image.pdf');
  };

  return (
    <div>
  <div style={{ textAlign: 'center', marginTop: '50px', border: '1px solid #e0e0e0', padding: 16, borderRadius: 6 }}>
      <h2>🖼️ Convert Image to PDF</h2>
      <input id="image-upload" type="file" accept="image/*" onChange={handleImageUpload} style={{display:'none'}} />
      <label htmlFor="image-upload" className="tool-button" style={{display:'inline-flex', alignItems:'center'}}><IconImage aria-hidden="true"/> Choose image</label>
      <br /><br />
      <button className="tool-button" onClick={handleConvert} disabled={!imageData}><IconImage aria-hidden="true"/> Download as PDF</button>
    </div>
    <div className="content">

  <h2>Image to PDF: Convert Your Images into a Clean, Shareable Document</h2>

  <p>
    Whether you have scanned photos, screenshots, receipts, notes, or multiple images 
    you want to organize into a single file, the Image to PDF tool makes it effortless. 
    With just a few clicks, you can transform your images into a polished, print-ready, 
    and easily shareable PDF document.
  </p>

  <p>
    No more sending multiple images separately—convert them into a single, structured 
    PDF for professional or personal use.
  </p>

  <h3>Why Convert Images to PDF?</h3>

  <ul>
    <li>Combine multiple images into one neat document</li>
    <li>Preserve image quality in a universal format</li>
    <li>Easily share, print, or archive your visuals</li>
    <li>Ensure consistent layout across devices</li>
    <li>Store important photos or scans in a secure format</li>
  </ul>

  <h3>How Image to PDF Conversion Works</h3>

  <h4>1. Upload Your Images</h4>
  <p>
    Start by selecting one or more images from your device. Supported formats include 
    JPG, PNG, JPEG, BMP, and more.
  </p>

  <h4>2. Arrange the Order</h4>
  <p>
    Drag and drop your images into the order you want them to appear in the final PDF. 
    Each image becomes one page in the document.
  </p>

  <h4>3. Adjust Layout Options</h4>
  <p>
    Customize your PDF with options like:
  </p>
  <ul>
    <li>Page size (A4, Letter, Original image size)</li>
    <li>Orientation (Portrait or Landscape)</li>
    <li>Margins and spacing</li>
    <li>Fit-to-page or full-size rendering</li>
  </ul>

  <h4>4. Generate Your PDF</h4>
  <p>
    Once everything looks perfect, click “Convert.” The system processes your images and 
    compiles them into a high-quality PDF that maintains clarity and structure.
  </p>

  <h3>Your Final PDF</h3>
  <p>
    The final document is a clean, unified PDF ready for sharing, printing, or uploading. 
    It looks consistent on any device and preserves the original image details.
  </p>

</div>
    </div>
  );
};

export default ImageToPDF;
